import React, { useEffect, useState } from 'react';
import './ShiftDetailComponent.scss';
import { Mixpanel } from 'helpers/Mixpanel';
import formatter from '../../../duck/formatter';
import displayLogic from 'pages/ScheduleCalendar/duck/displayLogic';
import { injectIntl } from 'react-intl';
import { isValidObject } from 'helpers/validation';
import ShiftApplicantsComponentContainer from '../Applicants/ShiftApplicantsComponentContainer';
import ShiftApplicantCommentsContainer from '../Applicants/ShiftApplicantCommentsContainer';
import DetailChildCardHeaderComponent from './DetailChildCardHeaderComponent';
import service from 'pages/ScheduleCalendar/duck/service';
import presenter from 'pages/ScheduleCalendar/duck/presenter';
import ShiftFieldsComponentContainer from './ShiftFieldsComponentContainer';
import { LoadingSpinner } from 'components/GeneralComponents/LoadingSpinner';

const ShiftDetailComponent = ({
  allUsers,
  date,
  presentedShift,
  prepareToDeleteShift,
  prepareToCopyShift,
  cancelModal,
  loadApplicantsForShiftDispatch,
  userToAddShiftTo,
  shiftMatrix,
  weekRangeStart,
  handleTooltipShow,
  handleTooltipHide,
  applicants,
  loading,
  error,
  clearError,
  isOpenShiftConfigured,
  prepareToApproveApplicant,
  prepareToDenyApplicant,
  loadLocationRolesDispatch,
  loadLocationSkillsDispatch,
  locationId,
  isVTOConfigured,
  creationType,
}) => {
  const [selectedTab, setSelectedTab] = useState('fields');
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [showingComments, setShowingComments] = useState(false);
  const [applicantToShowCommentsFor, setApplicantToShowCommentsFor] = useState(null);

  useEffect(() => {
    loadLocationRolesDispatch(locationId);
    loadLocationSkillsDispatch(locationId);

    if (isValidObject(presentedShift) === true) {
      loadApplicantsForShiftDispatch(presentedShift.id);
      if (displayLogic.shouldShowApplicantListOnFirstLoad(presentedShift) === true) {
        setSelectedTab('applicants');
      }
    }
  }, [presentedShift, loadApplicantsForShiftDispatch]);

  const handleCancel = () => {
    cancelModal();
    Mixpanel.track('Cancel shift detail');
  };

  const isViewingShift = isValidObject(presentedShift) === true;
  const dateToAddShiftTo = formatter.shiftTitleDate(date);
  const subtype = service.getShiftSubType(presentedShift);

  const showChildCardHeader = displayLogic.shouldShowChildCardHeader(subtype);
  const applicantId = service.getApplicantIdFromChildCard(presentedShift, subtype)
  const applicantUserId = service.getApplicantUserIdFromChildCard(presentedShift, subtype)
  const applicantNumText = presenter.applicantNumberText(applicants.length)

  console.log("Shift: " + JSON.stringify(presentedShift));

  if (loading) {
    return (
      <div className="loading-modal">
        <div className="loading-dialog">
          <div className="spinner"></div>
          <div className="loading-text">Loading...</div>
        </div>
      </div>
    );
  }

  else if (error) {
    return (
      <div className="shift-detail-error-wrapper">
        <div
          role="alert"
          className="shift-detail-error-banner"
        >
          <span className="error-text">{error}</span>
          <button
            type="button"
            aria-label="Dismiss error"
            className="error-close-btn"
            onClick={clearError}
          >
            ×
          </button>
        </div>
      </div>
    );
  }
  else {
    return (
      <div className="shift-detail-container">
        <div className="title-row">
          <label className="title">
            {isViewingShift === true && formatter.shiftDetailTitle(presentedShift)}
            {isViewingShift === false && presenter.createTitleText(creationType, dateToAddShiftTo)}
          </label>
          <button className="detail-close-button" onClick={handleCancel}>
            <img src="icons/close-simple.svg" alt="Close" />
          </button>
        </div>

        {showChildCardHeader == true && <DetailChildCardHeaderComponent shift={presentedShift} allUsers={allUsers} selectedApplicant={selectedApplicant} />}

        {displayLogic.shouldShowSectionTab(presentedShift) == true &&
          <div className="section-tab">

            <button className={`tab-button ${selectedTab === 'fields' ? 'active' : ''}`} onClick={() => setSelectedTab('fields')} >
              {presenter.detailsText(subtype)}
            </button>

            {displayLogic.shouldShowApplicantsTabOnDetail(presentedShift) == true &&
              <button className={`tab-button ${selectedTab === 'applicants' ? 'active' : ''}`} onClick={() => setSelectedTab('applicants')} >
                {applicantNumText}
              </button>}

            {displayLogic.shouldShowCommentsTabOnDetail(presentedShift) == true &&
              <button className={`tab-button ${selectedTab === 'comments' ? 'active' : ''}`} onClick={() => setSelectedTab('comments')} >
                Comments
              </button>}

          </div>}

        {selectedTab === 'fields' && (
          <ShiftFieldsComponentContainer
            presentedShift={presentedShift}
            cancelModal={cancelModal}
            prepareToDeleteShift={prepareToDeleteShift}
            prepareToCopyShift={prepareToCopyShift}
            date={date}
            userToAddShiftTo={userToAddShiftTo}
            applicants={applicants}
            isOpenShiftConfigured={isOpenShiftConfigured}
            isVTOConfigured={isVTOConfigured}
            creationType={creationType}
            loadLocationSkillsDispatch={loadLocationSkillsDispatch}
          />)}

        {selectedTab === 'applicants' &&
          <ShiftApplicantsComponentContainer
            presentedShift={presentedShift}
            shiftMatrix={shiftMatrix}
            weekRangeStart={weekRangeStart}
            handleTooltipHide={handleTooltipHide}
            handleTooltipShow={handleTooltipShow}
            selectedApplicantId={selectedApplicantId}
            setSelectedApplicantId={setSelectedApplicantId}
            selectedApplicant={selectedApplicant}
            setSelectedApplicant={setSelectedApplicant}
            showingComments={showingComments}
            setShowingComments={setShowingComments}
            applicantToShowCommentsFor={applicantToShowCommentsFor}
            setApplicantToShowCommentsFor={setApplicantToShowCommentsFor}
            prepareToApproveApplicant={prepareToApproveApplicant}
            prepareToDenyApplicant={prepareToDenyApplicant}
          />}

        {selectedTab === 'comments' &&
          <ShiftApplicantCommentsContainer
            presentedShift={presentedShift}
            applicantId={applicantId}
            applicantUserId={applicantUserId} />}

      </div>
    );
  }
};

export default injectIntl(ShiftDetailComponent);
